export default __webpack_public_path__ + "static/media/BELLogo2019.c70cbe27.png";